
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexJkISijdxEmRkgpE90NPqufP1MqcPmGJ0PR7BprZXygwMeta } from "/builds/hotelschool-the-hague/hotelschool-frontend/pages/index.vue?macro=true";
import { default as search2CiZvNmCYa0auhTzQaJ7rzlwap3pZR2h0wPJw_45IBF4YMeta } from "/builds/hotelschool-the-hague/hotelschool-frontend/pages/search.vue?macro=true";
import { default as connect6SA4Z_r9aVF4HXcdznYJGuRWlP6AQdI_45xscn0yxBXHcMeta } from "/builds/hotelschool-the-hague/hotelschool-frontend/pages/connect.vue?macro=true";
import { default as _91_46_46_46slug_93B9om6_8YnR3BgK9il9TUCZF2HOFmwdlb_wEtk8Kci0oMeta } from "/builds/hotelschool-the-hague/hotelschool-frontend/pages/[...slug].vue?macro=true";
import { default as indexa61fe0RqHcFh4P0eR4aRIyO2rdtAHYcpQ_siIme4T6QMeta } from "/builds/hotelschool-the-hague/hotelschool-frontend/pages/blog/index.vue?macro=true";
import { default as indexXPVc6iNCTlbIafIQCvJEFUZAQ8ep_KtP15RcKJts9RIMeta } from "/builds/hotelschool-the-hague/hotelschool-frontend/pages/hicons/index.vue?macro=true";
import { default as _91slug_93_y3dEcF7akOtQ9VV8St3WlQOBIAqbTdtUlONvNGdfAkMeta } from "/builds/hotelschool-the-hague/hotelschool-frontend/pages/hicons/[slug].vue?macro=true";
import { default as index0KQJaLDRhjTGrJXs4WE9gHCJHDAe12vT5FvjUcYn0RQMeta } from "/builds/hotelschool-the-hague/hotelschool-frontend/pages/meet-us/index.vue?macro=true";
import { default as _91category_93k5XDuwWqM8Rb1d7xFL2HqAnojOq295JAjRjBaLq22t0Meta } from "/builds/hotelschool-the-hague/hotelschool-frontend/pages/meet-us/[category].vue?macro=true";
import { default as _91_46_46_46slug_93enSmpZFaqMkeVNoIpYKtngXN_5tQpaKyK6eImFbN3HUMeta } from "/builds/hotelschool-the-hague/hotelschool-frontend/pages/partners/[...slug].vue?macro=true";
import { default as indexTS0uat0IfwMn7iV8yuNT5Ly25MlknCS8bL_45q8bfsUs0Meta } from "/builds/hotelschool-the-hague/hotelschool-frontend/pages/blog/[category]/index.vue?macro=true";
import { default as index6Up56HKm2Diy6PVxpyR5ml9_456noGjidcGzJ_45Ismc_45PcMeta } from "/builds/hotelschool-the-hague/hotelschool-frontend/pages/hicons/nominate/index.vue?macro=true";
import { default as _91slug_939RW6mivVS8pkEU2Q_45sZfCGDBbCLGm97ky_RuSX26eecMeta } from "/builds/hotelschool-the-hague/hotelschool-frontend/pages/blog/[category]/[slug].vue?macro=true";
import { default as you_45are_45nominatedmw947KmPsGSuZAxTuvMC1zw64iHskdlLJfxYtPhvAYgMeta } from "/builds/hotelschool-the-hague/hotelschool-frontend/pages/hicons/you-are-nominated.vue?macro=true";
import { default as thank_45youFUUjqg0EQ5y0KBjbWwjNFZe7nfMKwuHsDfY6uZ2CF1gMeta } from "/builds/hotelschool-the-hague/hotelschool-frontend/pages/hicons/nominate/thank-you.vue?macro=true";
import { default as component_45stubqNzEqDV3siso1JluGvUpdqGIkjImJJrveHtMUI_45jhqgMeta } from "/builds/hotelschool-the-hague/hotelschool-frontend/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubqNzEqDV3siso1JluGvUpdqGIkjImJJrveHtMUI_45jhqg } from "/builds/hotelschool-the-hague/hotelschool-frontend/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index___en",
    path: "/",
    component: () => import("/builds/hotelschool-the-hague/hotelschool-frontend/pages/index.vue")
  },
  {
    name: "search___en",
    path: "/search",
    component: () => import("/builds/hotelschool-the-hague/hotelschool-frontend/pages/search.vue")
  },
  {
    name: "connect___en",
    path: "/connect",
    component: () => import("/builds/hotelschool-the-hague/hotelschool-frontend/pages/connect.vue")
  },
  {
    name: "slug___en",
    path: "/:slug(.*)*",
    component: () => import("/builds/hotelschool-the-hague/hotelschool-frontend/pages/[...slug].vue")
  },
  {
    name: "blog___en",
    path: "/blog",
    component: () => import("/builds/hotelschool-the-hague/hotelschool-frontend/pages/blog/index.vue")
  },
  {
    name: "hicons___en",
    path: "/hicons",
    component: () => import("/builds/hotelschool-the-hague/hotelschool-frontend/pages/hicons/index.vue")
  },
  {
    name: "hicons-slug___en",
    path: "/hicons/:slug()",
    component: () => import("/builds/hotelschool-the-hague/hotelschool-frontend/pages/hicons/[slug].vue")
  },
  {
    name: "meet-us___en",
    path: "/meet-us",
    component: () => import("/builds/hotelschool-the-hague/hotelschool-frontend/pages/meet-us/index.vue")
  },
  {
    name: "meet-us-category___en",
    path: "/meet-us/:category()",
    component: () => import("/builds/hotelschool-the-hague/hotelschool-frontend/pages/meet-us/[category].vue")
  },
  {
    name: "partners-slug___en",
    path: "/partners/:slug(.*)*",
    component: () => import("/builds/hotelschool-the-hague/hotelschool-frontend/pages/partners/[...slug].vue")
  },
  {
    name: "blog-category___en",
    path: "/blog/:category()",
    component: () => import("/builds/hotelschool-the-hague/hotelschool-frontend/pages/blog/[category]/index.vue")
  },
  {
    name: "hicons-nominate___en",
    path: "/hicons/nominate",
    component: () => import("/builds/hotelschool-the-hague/hotelschool-frontend/pages/hicons/nominate/index.vue")
  },
  {
    name: "blog-category-slug___en",
    path: "/blog/:category()/:slug()",
    component: () => import("/builds/hotelschool-the-hague/hotelschool-frontend/pages/blog/[category]/[slug].vue")
  },
  {
    name: "hicons-you-are-nominated___en",
    path: "/hicons/you-are-nominated",
    component: () => import("/builds/hotelschool-the-hague/hotelschool-frontend/pages/hicons/you-are-nominated.vue")
  },
  {
    name: "hicons-nominate-thank-you___en",
    path: "/hicons/nominate/thank-you",
    component: () => import("/builds/hotelschool-the-hague/hotelschool-frontend/pages/hicons/nominate/thank-you.vue")
  },
  {
    name: component_45stubqNzEqDV3siso1JluGvUpdqGIkjImJJrveHtMUI_45jhqgMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubqNzEqDV3siso1JluGvUpdqGIkjImJJrveHtMUI_45jhqg
  },
  {
    name: component_45stubqNzEqDV3siso1JluGvUpdqGIkjImJJrveHtMUI_45jhqgMeta?.name,
    path: "/index-sitemap.xml",
    component: component_45stubqNzEqDV3siso1JluGvUpdqGIkjImJJrveHtMUI_45jhqg
  },
  {
    name: component_45stubqNzEqDV3siso1JluGvUpdqGIkjImJJrveHtMUI_45jhqgMeta?.name,
    path: "/en-US-sitemap.xml",
    component: component_45stubqNzEqDV3siso1JluGvUpdqGIkjImJJrveHtMUI_45jhqg
  }
]